<div class="pt-3 pl-md-4 mb-6">

  <div class="floating-alert-container">
    <div class="alert alert-success alert-dismissible" role="alert" *ngIf="successMessage">
      {{ successMessage }}
      <button type="button" class="close" (click)="successMessage = ''">
        <span aria-hidden="true">&times;</span>
      </button>
    </div>

    <div class="alert alert-danger alert-dismissible" role="alert" *ngIf="errorMessage">
      {{ errorMessage }}
      <button type="button" class="close" (click)="errorMessage = ''">
        <span aria-hidden="true">&times;</span>
      </button>
    </div>

    <div class="alert alert-dismissible" role="alert"
         [class.alert-success]="modalResult.status === CallbackResultStatus.success"
         [class.alert-danger]="modalResult.status === CallbackResultStatus.error"
         *ngIf="modalResult">
      {{ modalResult.text }}
      <button type="button" class="close" (click)="modalResult = null">
        <span aria-hidden="true">&times;</span>
      </button>
    </div>

    <div class="alert alert-info" role="alert" *ngIf="isLoading()">
      Loading...
    </div>

    <div class="alert alert-info" role="alert" *ngIf="isSaving()">
      Saving...
    </div>
  </div>

  <div class="gift-center-home-page-bar d-flex justify-content-between align-items-center mb-3">
    <nav aria-label="breadcrumb">
      <ol class="breadcrumb mb-0">
        <li class="breadcrumb-item"><a routerLink="/admin">
          Admin
        </a></li>
        <li class="breadcrumb-item"><a routerLink="/gifting-config">
          Gift Center
        </a></li>
        <li class="breadcrumb-item active" aria-current="page">
          Home Page
        </li>
      </ol>
    </nav>
    <div class="text-nowrap">
      <button type="button" class="btn btn-outline-primary mr-2"
              (click)="openPreview()"
              [disabled]="!canPreview()">
        Preview
      </button>
      <button type="button" class="btn btn-primary"
              (click)="save()"
              [disabled]="!canSave()">
        Save
      </button>
    </div>
  </div>

  <h2>Gift Center Home Page</h2>

  <p>
    These settings shape the Gift Center home page your customers see in the Climber App. The alert and the image carousel also appear on the Give a Gift page.
  </p>

  <h2 *ngIf="serverError !== null">
    Server Error: {{ serverError }}
  </h2>

  <ng-container *ngIf="(serverError === null) && pageLoaded()">

    <h3 class="mt-4">Alert</h3>

    <div class="form-group">
      <div class="form-check">
        <input class="form-check-input" type="checkbox"
               name="gift_center_alert_enabled"
               id="gift_center_alert_enabled"
               [(ngModel)]="orgConfig.gift_center_alert_enabled"
               (ngModelChange)="markAlertDirty()"
               [disabled]="saving">
        <label class="form-check-label" for="gift_center_alert_enabled">
          Show an alert on the Gift Center
        </label>
      </div>
      <div class="form-text text-danger">{{ errors.gift_center_alert_enabled }}</div>
      <ng-container *ngIf="!orgConfig.gift_center_alert_enabled">
        <div class="form-text text-danger">{{ errors.gift_center_alert_text }}</div>
        <div class="form-text text-danger">{{ errors.gift_center_alert_start_date }}</div>
        <div class="form-text text-danger">{{ errors.gift_center_alert_end_date }}</div>
        <div class="form-text text-danger" *ngIf="alertDatesInverted()">
          The End Date must not be before the Start Date.
        </div>
      </ng-container>
    </div>

    <div class="indented-subsection" *ngIf="orgConfig.gift_center_alert_enabled">

      <div class="form-group">
        <label for="gift_center_alert_text">Message</label>
        <div class="row">
          <div class="col-lg-8">
            <textarea class="form-control"
                      id="gift_center_alert_text"
                      name="gift_center_alert_text"
                      rows="3"
                      [(ngModel)]="orgConfig.gift_center_alert_text"
                      (ngModelChange)="markAlertDirty()"
                      [disabled]="saving"></textarea>
          </div>
        </div>
        <small class="form-text text-muted">
          Supports bold, italics and links (Markdown).
        </small>
        <div class="form-text text-danger" *ngIf="alertMessageMissing()">
          Enter the alert message, or turn the alert off.
        </div>
        <div class="form-text text-danger">{{ errors.gift_center_alert_text }}</div>
      </div>

      <div class="form-group">
        <label for="gift_center_alert_color_hex">Color</label>
        <div class="row">
          <div class="col-md-6 col-lg-4">
            <app-color-picker [id]="'gift_center_alert_color_hex'"
                              [content]="alertColorHex()"
                              [resetLabel]="orgConfig.gift_center_alert_color_hex ? 'Reset to the default color' : ''"
                              [disabled]="saving"
                              (contentChange)="orgConfig.gift_center_alert_color_hex = $event; markAlertDirty()"
                              (resetSelected)="orgConfig.gift_center_alert_color_hex = ''; markAlertDirty()"></app-color-picker>
          </div>
        </div>
        <div class="form-text text-danger">{{ errors.gift_center_alert_color_hex }}</div>
      </div>

      <div class="form-group">
        <label class="mb-1">Dates (optional)</label>
        <div class="row">
          <div class="col-lg-6 col-md-8">
            <div class="row">
              <div class="col">
                <label for="giftCenterAlertStartDateInput">Start Date</label>
                <app-date-picker [id]="'giftCenterAlertStartDateInput'"
                                 [content]="orgConfig.gift_center_alert_start_date"
                                 [disabled]="saving"
                                 (contentChange)="orgConfig.gift_center_alert_start_date = $event; markAlertDirty()"></app-date-picker>
                <div class="form-text text-danger">{{ errors.gift_center_alert_start_date }}</div>
              </div>
              <div class="col">
                <label for="giftCenterAlertEndDateInput">End Date</label>
                <app-date-picker [id]="'giftCenterAlertEndDateInput'"
                                 [content]="orgConfig.gift_center_alert_end_date"
                                 [disabled]="saving"
                                 (contentChange)="orgConfig.gift_center_alert_end_date = $event; markAlertDirty()"></app-date-picker>
                <div class="form-text text-danger">{{ errors.gift_center_alert_end_date }}</div>
                <div class="form-text text-danger" *ngIf="alertDatesInverted()">
                  The End Date must not be before the Start Date.
                </div>
              </div>
            </div>
          </div>
        </div>
        <small class="form-text text-muted">
          If provided, the alert shows only from the beginning of the Start Date to the end of the End Date, in the local time of your organization.
        </small>
      </div>

      <div class="form-group">
        <label>Preview</label>
        <div class="row">
          <div class="col-lg-8">
            <div class="rounded p-3 gift-center-alert-preview"
                 [style.background]="'#' + alertColorHex()"
                 [style.color]="isLightColor(alertColorHex()) ? 'black' : 'white'"
                 [innerHtml]="markdownRenderService.getRenderedMarkdown(orgConfig.gift_center_alert_text || '')"></div>
          </div>
        </div>
      </div>

    </div>

    <h3 class="mt-5">Image Carousel</h3>
    <small class="form-text text-muted mt-0 mb-3">
      Images are saved as you add, reorder or remove them.
    </small>

    <div class="form-group">
      <label for="gift_center_carousel_title">Title</label>
      <div class="row">
        <div class="col-md-6 col-lg-4">
          <input type="text" class="form-control"
                 id="gift_center_carousel_title"
                 name="gift_center_carousel_title"
                 maxlength="60"
                 [(ngModel)]="orgConfig.gift_center_carousel_title"
                 (ngModelChange)="markCarouselTitleDirty()"
                 [disabled]="saving">
        </div>
      </div>
      <small class="form-text text-muted">
        Shown in a bar above the images. Leave blank for no bar.
      </small>
      <div class="form-text text-danger">{{ errors.gift_center_carousel_title }}</div>
    </div>

    <div class="row">
      <div class="col-lg-8">
        <div cdkDropList (cdkDropListDropped)="dropCarouselImage($event)"
             [cdkDropListDisabled]="savingCarouselImages">
          <div class="rounded-border rounded-tight p-2 mb-2 d-flex align-items-center bg-white"
               style="gap: 12px;"
               *ngFor="let image of carouselImages" cdkDrag>
            <span class="text-muted" cdkDragHandle
                  style="font-size: 18px; line-height: 1; cursor: move;">&#8801;</span>
            <img *ngIf="image.image"
                 [src]="image.image"
                 class="rounded"
                 style="width: 160px; height: 90px; object-fit: cover;"
                 alt="Carousel image">
            <div *ngIf="!image.image"
                 class="d-flex justify-content-center align-items-center rounded"
                 style="background-color: #d6d6d6; width: 160px; height: 90px;">
              <div>No image</div>
            </div>
            <div class="flex-grow-1">
              {{ carouselImageSummary(image) }}
              <div *ngIf="!image.is_giftable && image.product_type">
                <span class="badge badge-warning">Not currently giftable</span>
              </div>
            </div>
            <div class="d-flex" style="gap: 12px;">
              <button type="button" class="btn btn-sm btn-outline-primary"
                      (click)="handleEditCarouselImage(image)"
                      [disabled]="savingCarouselImages">
                Edit
              </button>
              <button type="button" class="btn btn-sm btn-outline-danger"
                      (click)="handleRemoveCarouselImage(image)"
                      [disabled]="savingCarouselImages">
                Remove
              </button>
            </div>
          </div>
        </div>

        <p class="text-muted" *ngIf="carouselImages.length === 0">
          No images added.
        </p>
      </div>
    </div>

    <div class="d-inline-block"
         [ngbTooltip]="carouselImages.length >= MAX_CAROUSEL_IMAGES ? 'Up to ' + MAX_CAROUSEL_IMAGES + ' images' : null"
         container="body">
      <button type="button" class="btn btn-success"
              (click)="handleAddCarouselImage()"
              [disabled]="carouselImages.length >= MAX_CAROUSEL_IMAGES || savingCarouselImages">
        Add Image
      </button>
    </div>

    <h3 class="mt-5">Popular Gifts</h3>

    <ng-container *ngIf="giftableProducts.length > 0">
      <div class="form-group">
        <label for="newFeaturedGift">Gift</label>
        <div class="row">
          <div class="col-md-6 col-lg-4">
            <select class="custom-select"
                    id="newFeaturedGift"
                    name="newFeaturedGift"
                    [(ngModel)]="newFeaturedGiftKey"
                    [disabled]="saving || featuredGifts.length >= MAX_FEATURED_GIFTS">
              <option [ngValue]="null">Choose a gift</option>
              <ng-container *ngFor="let group of GIFTABLE_PRODUCT_GROUPS">
                <optgroup *ngIf="productsOfType(unfeaturedGiftableProducts(), group.productType).length > 0"
                          [label]="group.label">
                  <option *ngFor="let product of productsOfType(unfeaturedGiftableProducts(), group.productType)"
                          [ngValue]="getGiftableProductKey(product)">
                    {{ product.name }}
                  </option>
                </optgroup>
              </ng-container>
            </select>
          </div>
          <div class="col-auto">
            <div class="d-inline-block"
                 [ngbTooltip]="featuredGifts.length >= MAX_FEATURED_GIFTS ? 'Up to ' + MAX_FEATURED_GIFTS + ' gifts' : null"
                 container="body">
              <button type="button" class="btn btn-success"
                      (click)="addFeaturedGift()"
                      [disabled]="newFeaturedGiftKey === null || featuredGifts.length >= MAX_FEATURED_GIFTS || saving">
                Add
              </button>
            </div>
          </div>
        </div>
      </div>
    </ng-container>

    <p *ngIf="giftableProducts.length === 0">
      No giftable products yet.
      <a routerLink="/gifting-config">Add a gift config</a>
    </p>

    <div class="row">
      <div class="col-lg-8">
        <div cdkDropList (cdkDropListDropped)="dropFeaturedGift($event)"
             [cdkDropListDisabled]="saving">
          <div class="rounded-border rounded-tight p-2 mb-2 d-flex align-items-center bg-white"
               style="gap: 12px;"
               *ngFor="let gift of featuredGifts; let i = index" cdkDrag>
            <span class="text-muted" cdkDragHandle
                  style="font-size: 18px; line-height: 1; cursor: move;">&#8801;</span>
            <div class="flex-grow-1">
              <small class="text-muted d-block">{{ getGiftProductTypeDisplay(gift.product_type) }}</small>
              {{ gift.product_name }}
              <span class="text-muted">{{ gift.price_display }}</span>
              <div class="d-flex flex-wrap" style="gap: 8px;"
                   *ngIf="gift.tag_text || !gift.is_giftable">
                <span *ngIf="gift.tag_text"
                      class="badge badge-pill"
                      [style.background]="'#' + (gift.tag_color_hex || defaultTagColorHex())"
                      [style.color]="isLightColor(gift.tag_color_hex || defaultTagColorHex()) ? 'black' : 'white'">
                  {{ gift.tag_text }}
                </span>
                <span *ngIf="!gift.is_giftable" class="badge badge-warning">Not currently giftable</span>
              </div>
            </div>
            <button type="button" class="btn btn-sm btn-outline-danger"
                    (click)="removeFeaturedGift(i)"
                    [disabled]="saving">
              Remove
            </button>
          </div>
        </div>

        <p class="text-muted" *ngIf="featuredGifts.length === 0">
          No popular gifts chosen.
        </p>
      </div>
    </div>

    <h3 class="mt-5">Gift Tags and Descriptions</h3>

    <p>
      A tag highlights a gift on the Popular gifts and Give a Gift cards. A short description is one line under the gift's name on the Give a Gift page; up to 40 characters, so it fits on a phone.
    </p>

    <p *ngIf="giftableProducts.length === 0">
      No giftable products yet.
      <a routerLink="/gifting-config">Add a gift config</a>
    </p>

    <ng-container *ngIf="giftableProducts.length > 0">
      <div class="rounded-table-wrapper table-responsive-lg mb-2">
        <table class="table table-hover">

          <thead>
          <tr>
            <th>Type</th>
            <th>Name</th>
            <th>Tag text</th>
            <th>Color</th>
            <th>Short description</th>
          </tr>
          </thead>

          <tbody style="line-height: 16px;">
          <tr *ngFor="let row of giftTagRows; let i = index">
            <td>{{ getGiftProductTypeDisplay(row.product.product_type) }}</td>
            <td>{{ row.product.name }}</td>
            <td>
              <div class="d-flex align-items-center" style="gap: 8px;">
                <input type="text" class="form-control form-control-sm"
                       [id]="'giftTagText' + i"
                       [name]="'giftTagText' + i"
                       maxlength="30"
                       [attr.aria-label]="'Tag text for ' + row.product.name"
                       [(ngModel)]="row.tag_text"
                       (ngModelChange)="markGiftTagsDirty()"
                       [disabled]="saving">
                <small class="text-muted text-nowrap">{{ row.tag_text.length }}/30</small>
              </div>
              <div class="text-danger small mt-1" *ngIf="giftTagRowError(row)">
                {{ giftTagRowError(row) }}
              </div>
            </td>
            <td>
              <div class="d-flex align-items-center">
                <app-color-picker [id]="'giftTagColor' + i"
                                  [compact]="true"
                                  [size]="'lg'"
                                  [ariaLabel]="'Tag color for ' + row.product.name"
                                  [content]="row.tag_color_hex || defaultTagColorHex()"
                                  [resetLabel]="row.tag_color_hex ? 'Reset to the default color' : ''"
                                  [disabled]="saving"
                                  (contentChange)="row.tag_color_hex = $event; markGiftTagsDirty()"
                                  (resetSelected)="row.tag_color_hex = ''; markGiftTagsDirty()"></app-color-picker>
              </div>
            </td>
            <td>
              <div class="d-flex align-items-center" style="gap: 8px;">
                <input type="text" class="form-control form-control-sm"
                       [id]="'giftShortDescription' + i"
                       [name]="'giftShortDescription' + i"
                       maxlength="40"
                       [attr.aria-label]="'Short description for ' + row.product.name"
                       [(ngModel)]="row.short_description"
                       (ngModelChange)="markGiftTagsDirty()"
                       [disabled]="saving">
                <small class="text-muted text-nowrap">{{ row.short_description.length }}/40</small>
              </div>
            </td>
          </tr>
          </tbody>

        </table>
      </div>
    </ng-container>

  </ng-container>

</div>
